import { WIDGET } from "src/common/constants";
import { WidgetI } from "src/types/Widget";

export const SET_WIDGETS = "SET_WIDGETS" as const;

export const UPDATE_WIDGET_ORDER_SAGA = `${WIDGET}_UPDATE_ORDER_SAGA` as const;
export const UPDATE_WIDGET_ORDER = `${WIDGET}_UPDATE_ORDER` as const;

export const UPDATE_WIDGET_PROPS_SAGA = `${WIDGET}_UPDATE_PROPS_SAGA` as const;
export const UPDATE_WIDGET_PROPS = `${WIDGET}_UPDATE_PROPS` as const;

export const setWidgets = (payload: WidgetI[]) => ({
  type: SET_WIDGETS,
  widgets: payload,
});

export const updateWidgetOrderSaga = (oldIndex: number, newIndex: number) => ({
  type: UPDATE_WIDGET_ORDER_SAGA,
  oldIndex,
  newIndex,
});
export const updateWidgetOrder = (oldIndex: number, newIndex: number) => ({
  type: UPDATE_WIDGET_ORDER,
  oldIndex,
  newIndex,
});

export const updateWidgetPropsSaga = (index: number, props: WidgetI) => ({
  type: UPDATE_WIDGET_PROPS_SAGA,
  index,
  props,
});
export const updateWidgetProps = (index: number, props: WidgetI) => ({
  type: UPDATE_WIDGET_PROPS,
  index,
  props,
});
